import { render, staticRenderFns } from "./purchase-status.vue?vue&type=template&id=4f14d3c5&"
import script from "./purchase-status.vue?vue&type=script&lang=js&"
export * from "./purchase-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports